export const defaultPieceTemplate = (baseDate: Date = new Date()) => `{
  "containerType": "PALLET",
  "containerSubtype": "EURO_PALLET",
  "goodsDescription": "Consumer electronics",
  "turnable": false,
  "stackingMaxNumber": 2,
  "grossWeight": {
    "value": 280,
    "unit": "KGM"
  },
  "netWeight": {
    "value": 250,
    "unit": "KGM"
  },
  "dimensions": {
    "length": {
      "value": 120,
      "unit": "CMT"
    },
    "width": {
      "value": 80,
      "unit": "CMT"
    },
    "height": {
      "value": 160,
      "unit": "CMT"
    }
  },
  "containedItems": [
    {
      "uri": "urn:bol:item:item-001"
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "PROVIDER_ID",
      "reference": "PCE-${baseDate.getUTCFullYear()}-001"
    }
  ],
  "specialRegulations": [
    {
      "specialRegulationType": "NON_STACKABLE"
    }
  ]
}`;
